// Función para formatear el texto del análisis
const formatearTextoAnalisis = (texto) => {
  return texto
    .replace(/\r\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

// Función para extraer datos del análisis
export const extraerDatosAnalisis = (analisisTexto) => {
  // Formatear el texto para asegurar consistencia
  const textoFormateado = formatearTextoAnalisis(analisisTexto);

  // Extraer cada sección con expresiones regulares mejoradas
  const nivelUrgenciaMatch = textoFormateado.match(/NIVEL DE URGENCIA:[\s\n]*(ESI-[1-5])/i);
  
  // Validar que se encontró un nivel de urgencia
  if (!nivelUrgenciaMatch) {
    throw new Error('No se pudo determinar el nivel de urgencia del análisis');
  }

  // Extraer el resto de la información
  const diagnosticoPreliminarMatch = textoFormateado.match(/DIAGNÓSTICO PRELIMINAR:[\s\n]*([\s\S]*?)(?=\n\n|$)/i);
  const sintomasMatch = textoFormateado.match(/SÍNTOMAS IDENTIFICADOS:[\s\n]*([\s\S]*?)(?=\n\n|$)/i);
  const signosAlarmaMatch = textoFormateado.match(/SIGNOS DE ALARMA:[\s\n]*([\s\S]*?)(?=\n\n|$)/i);
  const recomendacionesMatch = textoFormateado.match(/RECOMENDACIONES:[\s\n]*([\s\S]*?)(?=\n\n|$)/i);
  const centroMatch = textoFormateado.match(/CENTRO RECOMENDADO:[\s\n]*([\s\S]*?)(?=\n\n|$)/i);

  // Procesar cada campo con manejo de errores mejorado
  const procesarLista = (texto) => {
    if (!texto) return [];
    return texto
      .split('\n')
      .map(s => s.trim())
      .filter(s => s.startsWith('-'))
      .map(s => s.substring(1).trim())
      .filter(Boolean);
  };

  // Obtener y validar el nivel de urgencia
  const nivelUrgencia = nivelUrgenciaMatch[1].trim().toUpperCase();
  if (!/^ESI-[1-5]$/.test(nivelUrgencia)) {
    throw new Error(`Nivel de urgencia inválido: ${nivelUrgencia}`);
  }

  return {
    nivelUrgencia,
    diagnosticoPreliminar: diagnosticoPreliminarMatch ? diagnosticoPreliminarMatch[1].trim() : '',
    sintomas: sintomasMatch ? procesarLista(sintomasMatch[1]) : [],
    signosAlarma: signosAlarmaMatch ? procesarLista(signosAlarmaMatch[1]) : [],
    recomendaciones: recomendacionesMatch ? procesarLista(recomendacionesMatch[1]) : [],
    centroRecomendado: centroMatch ? centroMatch[1].trim() : ''
  };
}; 